import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=2845b9d7&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=2845b9d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2845b9d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2845b9d7')) {
      api.createRecord('2845b9d7', component.options)
    } else {
      api.reload('2845b9d7', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=2845b9d7&scoped=true&", function () {
      api.rerender('2845b9d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/Header.vue"
export default component.exports